import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class FacebookUserDataTrackingEvent extends BasicTrackingEvent {

    private _playerId: number;
    private _timestamp: number;
    private _facebookId: string;
    private _isAccountVerified: number;
    private _fullName: string;

    private _firstName: string;
    private _lastName: string;
    private _profileLink: string;
    private _gender: string;
    private _locale: string;
    private _ageRange: string;
    private _utcOffset: number;
    private _birthday: string;
    private _email: string;
    private _facebookBusinessToken: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};

        vars.playerId = this._playerId;
        vars.timestamp = this._timestamp;
        vars.facebook_id = this._facebookId;
        vars.is_account_verified = this._isAccountVerified;
        vars.full_name = this._fullName;
        // optional fields
        if (this._firstName) {
            vars.first_name = this._firstName;
        }
        if (this._lastName) {
            vars.last_name = this._lastName;
        }
        if (this._profileLink) {
            vars.profile_link = this._profileLink;
        }
        if (this._gender) {
            vars.gender_name = this._gender;
        }
        if (this._locale) {
            vars.locale_code = this._locale;
        }
        if (this._ageRange) {
            vars.facebook_age_range = this._ageRange;
        }
        if (!isNaN(this._utcOffset)) {
            vars.utc_offset = this._utcOffset;
        }
        if (this._birthday) {
            vars.birthday = this._birthday;
        }
        if (this._email) {
            vars.email = this._email;
        }
        if (this._facebookBusinessToken) {
            vars.facebook_business_token = this._facebookBusinessToken;
        }

        return vars;
    }

    public set playerId(value: number) {
        this._playerId = value;
    }

    public set timestamp(value: number) {
        this._timestamp = value;
    }

    public set facebookId(value: string) {
        this._facebookId = value;
    }

    public set isAccountVerified(value: number) {
        this._isAccountVerified = value;
    }

    public set fullName(value: string) {
        this._fullName = value;
    }

    public set firstName(value: string) {
        this._firstName = value;
    }

    public set lastName(value: string) {
        this._lastName = value;
    }

    public set profileLink(value: string) {
        this._profileLink = value;
    }

    public set gender(value: string) {
        this._gender = value;
    }

    public set locale(value: string) {
        this._locale = value;
    }

    public set ageRange(value: string) {
        this._ageRange = value;
    }

    public set utcOffset(value: number) {
        this._utcOffset = value;
    }

    public set birthday(value: string) {
        this._birthday = value;
    }

    public set email(value: string) {
        this._email = value;
    }

    public set facebookBusinessToken(value: string) {
        this._facebookBusinessToken = value;
    }
}
